import React from 'react';
import './About.css';

const About = () => {
    return (
        <div className='about-bg'>
            <div className='container about'>
            <h4>About</h4>
        </div>
        </div>
    );
};

export default About;